import React, { Component, PropTypes } from 'react'
import {partial} from 'lodash'
import classNames from 'classnames'

import StampChooser from './StampChooser'
import ControlledSelect from './ControlledSelect'

class WeightChooser extends Component {
  constructor() {
    super()
    this.state = { checked: false }
  }
 
  componentWillReceiveProps(nextProps) {
    this.setState({checked: nextProps.weight.selectedEngraving}); 
  }
  
  handleCheck(checkbox) {
    const weight = this.props.weight;
    const keys = weight.keys;

    if (!this.state.checked) {
      this.setState({ checked: true })
      this.props.onFieldChange(keys.weightEngraving, weight.engravingOption.id)

    } else {
      this.setState({ checked: false });
      this.props.onFieldChange(keys.weightEngraving, 0);
      this.props.onFieldChange(keys.weightEngravingToe, 0);
      this.props.onFieldChange(keys.weightEngravingHeel, 0);
    }
  }

  render() {
    const { weight, hasEngraving, onFieldChange, onSelectPaintFill, isError, isStampError, isPaintError, allowKeepAsIs } = this.props;
    const keys = weight.keys
    return (
      <div className={classNames("weight-chooser")}>
        <ControlledSelect
          showPrice={!!weight.weights[0].price}
          options={weight.weights}
          selected={weight.selected || (allowKeepAsIs ? "" : weight.weights[0])}
          onChange={partial(onFieldChange, keys.weight)}
          isError={isError}
        >
          {allowKeepAsIs &&
           <option value="">Keep As Is</option>
          }
        </ControlledSelect>
      </div>
    )
  }
}

let engravingShape = PropTypes.shape({
  loc:PropTypes.object.isRequired,
  selected:PropTypes.object,
  stamps:PropTypes.arrayOf(PropTypes.object).isRequired, 
}).isRequired;
let paintShape = PropTypes.shape({
  loc:PropTypes.object.isRequired,
  selected:PropTypes.object,
  paints:PropTypes.arrayOf(PropTypes.object).isRequired, 
}).isRequired;

WeightChooser.propTypes = {
  weight: PropTypes.shape({
    frontEngraving: engravingShape,
    rearEngraving: engravingShape,
    frontPaint: paintShape,
    rearPaint: paintShape, 
  }).isRequired,
  hasEngraving: PropTypes.bool.isRequired,
  isError: PropTypes.bool,
  isStampError: PropTypes.bool,
  isPaintError: PropTypes.bool,
  onFieldChange: PropTypes.func.isRequired,
  onSelectPaintFill: PropTypes.func.isRequired,
}

export default WeightChooser